import { createReducer } from 'reduxsauce';

export const Types = {
  CHANGE_FILTER: 'anchors/CHANGE_FILTER',
  CHANGE_LASTGRID: 'anchors/CHANGE_LASTGRID',
  CHANGE_LASTANCHOR: 'anchors/CHANGE_LASTANCHOR',
  CHANGE_LASTANCHOR_STORE: 'anchors/CHANGE_LASTANCHOR_STORE',
  CHANGE_MODAL: 'anchors/CHANGE_MODAL',
};

const INITIAL_STATE = {
  filters: [
    {
      anchor: 'ancoras-contatos',
      open: false,
      filter: null,
    },
    {
      anchor: 'ancoras-lojas',
      open: false,
      filter: null,
    },
    {
      anchor: 'ancoras-taxas-faixas',
      open: false,
      filter: null,
    },
    {
      anchor: 'ancoras-lojas-codigos',
      open: false,
      filter: null,
    },
  ],
  lastGrid: null,
  lastAnchor: null,
  lastAnchorStore: null,
};

/* const add = (state = INITIAL_STATE, action) => ({
  ...state,
  anchorsFilters: state.cardsDots.concat(action.payload)
}) */

const changeFilter = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    filters: state.filters.map((filter) =>
      filter.anchor === action.payload.anchor
        ? {
            ...filter,
            ...action.payload,
          }
        : filter,
    ),
  };
};

const changeModalOpen = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    filters: state.filters.map((filter) =>
      filter.anchor === action.payload.anchor
        ? {
            ...filter,
            open: !filter.open,
          }
        : filter,
    ),
  };
};

const changeLastGrid = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    lastGrid: action.payload,
  };
};

const changeLastAnchor = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    lastAnchor: action.payload,
  };
};

const changeLastAnchorStore = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    lastAnchorStore: action.payload,
  };
};

export default createReducer(INITIAL_STATE, {
  [Types.CHANGE_FILTER]: changeFilter,
  [Types.CHANGE_LASTGRID]: changeLastGrid,
  [Types.CHANGE_LASTANCHOR]: changeLastAnchor,
  [Types.CHANGE_LASTANCHOR_STORE]: changeLastAnchorStore,
  [Types.CHANGE_MODAL]: changeModalOpen,
});

export const CreatorsAnchors = {
  changeLastGrid: (lastGrid) => ({
    type: Types.CHANGE_LASTGRID,
    payload: lastGrid,
  }),
  changeLastAnchor: (lastAnchor) => ({
    type: Types.CHANGE_LASTANCHOR,
    payload: lastAnchor,
  }),
  changeLastAnchorStore: (lastAnchorStore) => ({
    type: Types.CHANGE_LASTANCHOR_STORE,
    payload: lastAnchorStore,
  }),
  changeFilter: (filter) => ({
    type: Types.CHANGE_FILTER,
    payload: filter,
  }),
  changeModal: (anchor) => ({
    type: Types.CHANGE_MODAL,
    payload: anchor,
  }),
};
